/* globals Mixcloud */

import React from "react";
import classNames from "classnames";

import { StudioManager } from "../../studio-manager";


export class Episode extends React.Component {
  play = (e) => {
    e.preventDefault();
    if (!this.props.youtube) {
      var target = this.props.episode.url.replace('https://www.mixcloud.com', '');
      StudioManager.instance.widget.play(target);
    }
    if (this.props.youtube) {
      window.videoOverlay.show(this.props.episode.url);
    }
  }

  widgetReady = () => {
    window.widget.play();
  }

  hover = () => {
    if (window.main) window.main.next();
  }

  clickTag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    var tag = '#' + e.currentTarget.dataset.tag;
    console.log(tag);
    StudioManager.instance.search(tag);
    window.scrollTo(0, 0);
  }

  clickArtist = () => {
    StudioManager.instance.search(this.props.episode.title);
    window.scrollTo(0, 0);
  }

  cancelClick = (e) => {
    e.preventDefault();
  }

  render () {
    var _ = classNames({
      'episode': true,
      'episode--youtube': this.props.youtube
    });

    return (
      <a className={_} href={this.props.episode.url} target="_blank" onMouseOver={this.hover} onClick={this.cancelClick}>
        <div className="episode__image" style={{ backgroundImage: `url(${this.props.episode.image})`}} onClick={this.play} />
        <div className="episode__title" onClick={this.clickArtist}>{this.props.episode.title}</div>
        <div className="episode__meta">
          <div className="episode__meta__date">{this.props.episode.date.format('DD.MM.YYYY')}</div>
          <div className="episode__meta__tags">
            {this.props.episode.tags.map(
              tag => <span onClick={this.clickTag} className="tag" data-tag={tag} key={tag}>{ tag }</span>
            )}
          </div>
        </div>
      </a>
    );
  }
}